import { Team } from '../types';

export const buildTree = (teams: Team[]) => {
  const idMap = new Map<number, Team>(teams.map(t => [t.id, t]));
  const children = new Map<number, Team[]>();
  const roots: Team[] = [];
  const independent: Team[] = [];

  teams.forEach((t) => {
    if (t.parent_team === t.id) {
      roots.push(t);
    } else if (t.parent_team == null) {
      independent.push(t);
    } else if (idMap.has(t.parent_team)) {
      const arr = children.get(t.parent_team) || [];
      arr.push(t);
      children.set(t.parent_team, arr);
    } else {
      independent.push(t);
    }
  });

  children.forEach((arr) => {
    arr.sort((a, b) => a.name.localeCompare(b.name));
  });

  roots.sort((a, b) => a.name.localeCompare(b.name));
  independent.sort((a, b) => a.name.localeCompare(b.name));

  return { idMap, children, roots, independent };
};

export const hexToRgb = (hex?: string | null) => {
  if (!hex) return null;
  const cleaned = hex.replace('#', '').trim();
  if (cleaned.length === 3) {
    const r = parseInt(cleaned[0] + cleaned[0], 16);
    const g = parseInt(cleaned[1] + cleaned[1], 16);
    const b = parseInt(cleaned[2] + cleaned[2], 16);
    return { r, g, b };
  }
  if (cleaned.length === 6) {
    const r = parseInt(cleaned.slice(0, 2), 16);
    const g = parseInt(cleaned.slice(2, 4), 16);
    const b = parseInt(cleaned.slice(4, 6), 16);
    return { r, g, b };
  }
  return null;
};

export const isColorDark = (hex?: string | null) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return false;
  const lum = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
  return lum < 0.55;
};
